'use strict';

/* global $ */

import fancybox from '../vendor/jquery.fancybox';

import { recall } from './forms/popins/recall';
import { askQuestion } from './forms/popins/askQuestion';
import { registration } from './forms/popins/registration';

import * as conditioner from 'conditioner-core/conditioner-core.min';
require('es6-promise').polyfill();


// ETRE RAPPELE formulaire
let open_popin_recall = (e) => {
    e.preventDefault();
    var href;
    if (typeof $(e.currentTarget).attr('data-href') === 'string') {
        href = decodeURIComponent(escape(window.atob($(e.currentTarget).attr('data-href'))));
    } else {
        href = $(e.currentTarget).attr('href');
    }
    $.fancybox.open({
        src: href,
        type: 'ajax',
        opts: {
            filter: '.recallForm',
            baseClass: 'fullPopin gtm-popin-recall-form',
            clickSlide: false,
            clickOutside: false,
            touch: false,
            afterLoad: function () {
                conditioner.hydrate($('.fullPopin')[0]);
            }
        }
    });

    try {
        window.GQGoal('CLIC BOUTON ETRE RAPPELE');
    } catch (e) {
    }
};


$('.popin_recall').on('click', open_popin_recall);
let popin_recall_links = $("a[href$='#popin_recall']");
popin_recall_links.on('click', open_popin_recall);



// ETRE RAPPELE BUSINESS formulaire
let open_popin_business = (e) => {
    console.log('open popin busin');
    e.preventDefault();
    var href;
    if (typeof $(e.currentTarget).attr('data-href') === 'string') {
        href = decodeURIComponent(escape(window.atob($(e.currentTarget).attr('data-href'))));
    } else {
        href = $(e.currentTarget).attr('href');
    }
    $.fancybox.open({
        src: href,
        type: 'ajax',
        opts: {
            filter: '.businessForm',
            baseClass: 'fullPopin gtm-popin-business-form',
            clickSlide: false,
            clickOutside: false,
            touch: false,
            afterLoad: function () {
                conditioner.hydrate($('.fullPopin')[0]);
            }
        }
    });

    try {
        window.GQGoal('CLIC BOUTON ETRE RAPPELE POPIN BUSINESS');
    } catch (e) {
    }
};

$('.popin_business').on('click', open_popin_business);
let popin_business_links = $("a[href$='#popin_business']");
popin_business_links.on('click', open_popin_business);


// POSER UNE QUESTION formulaire
let open_popin_ask_question = (e) => {
    e.preventDefault();
    $.fancybox.open({
        src: $(e.currentTarget).attr('href'),
        type: 'ajax',
        opts: {
            filter: '.askQuestionForm',
            baseClass: 'fullPopin gtm-popin-askQuestion-form',
            clickSlide: false,
            clickOutside: false,
            touch: false,
            afterLoad: function () {
                conditioner.hydrate($('.fullPopin')[0]);
            }
        }
    });
};

$('.popin_ask_question').on('click', open_popin_ask_question);
let popin_ask_question = $("a[href$='#popin_ask_question']");
popin_ask_question.on('click', open_popin_ask_question);


// ouverture de popin en fonction d'un param dans l'url
let hash = window.location.hash;
if (hash) {
    if (hash === '#popin_rappel') {
        $('.popin_recall:first').trigger('click');
    } else if (hash === '#popin_business') {
        $('.popin_business:first').trigger('click');
    } else if (hash === '#popin_question') {
        $('.popin_ask_question:first').trigger('click');
    }
}


// INSCRIPTION ATELIERS formulaire
$(document).on('click', '.popin_workshop', (e) => {
    // e.preventDefault();
    let link = $(e.currentTarget);
    let url = link.attr('href');
    if (link.data('ev-link') !== '') {
        url = link.data('ev-link');
    }
    let event_data = {};
    event_data.type = link.data('ev-type');
    if (event_data.type === 'formation') {
        event_data.name = link.data('ev-name');
        event_data.date = link.data('ev-date');
        event_data.place = link.data('ev-place');
    }

    $.fancybox.open({
        src: url,
        type: 'ajax',
        opts: {
            filter: '.workshopForm',
            baseClass: 'fullPopin gtm-popin-workshop-form',
            clickSlide: false,
            clickOutside: false,
            touch: false,
            afterLoad: function () {
                closePopinBtn();
                $('.workshopForm').data('url', url);
                $('.workshopForm').data('event', event_data);
                conditioner.hydrate($('.fullPopin')[0]);
            }
        }
    });
});


// INSCRIPTION FORMATION formulaire
$(document).on('click', '.popin_training', (e) => {
    // e.preventDefault();
    let link = $(e.currentTarget);

    let url = link.attr('href');
    if (link.data('ev-link') !== '') {
        url = link.data('ev-link');
    }

    let event_data = {};
    event_data.type = link.data('ev-type');
    if (event_data.type === 'formation') {
        event_data.name = link.data('ev-name');
        event_data.date = link.data('ev-date');
        event_data.place = link.data('ev-place');
    }

    $.fancybox.open({
        src: url,
        type: 'ajax',
        opts: {
            filter: '.trainingForm',
            baseClass: 'fullPopin gtm-popin-training-form',
            clickSlide: false,
            clickOutside: false,
            touch: false,
            afterLoad: function () {
                closePopinBtn();
                $('.trainingForm').data('url', url);
                $('.trainingForm').data('event', event_data);
                conditioner.hydrate($('.fullPopin')[0]);
            }
        }
    });
});

if (window.location.hash) {
    let evtid = window.location.hash.substring(1).replace('evtid=', '');
    $('.js--popin_link[data-ev-evtid="' + evtid + '"]').click();
}

// BTN retour à la page
function closePopinBtn () {
    $('.popin_close').on('click', (e) => {
        e.preventDefault();
        $.fancybox.close();
    });
}



// WEBPACK FOOTER //
// ./front/js/modules/popinOpeners.js